import { IMAGE_ASPECT_RATIO } from './aspectRatio';
import { DEFAULT_IMAGE_STYLE_ID } from './image';
import { initImageOverlayProps } from './overlay';

export const DISABLED_BY_ADMIN_LABEL = 'Disabled by admin';
export const IMAGE_GENERATION_ENABLED_LABEL = 'Image generation enabled';
export const IMAGE_GENERATION_DISABLED_LABEL = 'Image generation disabled';

export const DEFAULT_IMAGE_SETTINGS = {
  imageStyleId: DEFAULT_IMAGE_STYLE_ID,
  imageAspectRatio: IMAGE_ASPECT_RATIO.ratio1x1,
  imageOverlayProperties: initImageOverlayProps(),
};
